import PrimaryButton from "../../../components/common/PrimaryButton";
import { MdOutlineShield } from "react-icons/md";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URI =
  process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
  `${window.location.origin}/google/callback`;

export default function GoogleAuthSection() {
  const googleAuth = localStorage.getItem("google_auth");

  const connectGoogle = () => {
    const url =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?response_type=code` +
      `&client_id=${CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=https://www.googleapis.com/auth/calendar.events` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(window.location.origin)}`;

    window.open(url, "Google OAuth", "width=500,height=650");
  };

  const logout = () => {
    localStorage.removeItem("google_auth");
    window.location.reload();
  };

  /* ---------------- DISCONNECTED ---------------- */
  if (!googleAuth) {
    return (
      <div className="zoom-auth-wrapper">
        <div className="zoom-auth-title">Authentication - Google Meet</div>

        <div className="zoom-auth-card warning">
          <div className="zoom-auth-left">
            <div className="zoom-auth-icon warning-icon">
              <MdOutlineShield />
            </div>

            <div>
              <div className="zoom-auth-heading">
                Connect Your Account
              </div>
              <div className="zoom-auth-subtext">
                To create and manage meetings, you need to authenticate with your Google account.
              </div>

              <PrimaryButton
                className="zoom-auth-btn"
                onClick={connectGoogle}
              >
                Connect Google
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ---------------- CONNECTED ---------------- */
  const user = JSON.parse(googleAuth)?.userEmail;

  return (
    <div className="zoom-auth-wrapper">
      <div className="zoom-auth-title">Authentication - Google Meet</div>

      <div className="zoom-auth-card success">
        <div className="zoom-auth-left">
          <div className="zoom-auth-icon success-icon">✓</div>

          <div>
            <div className="zoom-auth-heading">
              Connected
            </div>
            <div className="zoom-auth-subtext">
              {user}
            </div>
            <div className="zoom-auth-subtext muted">
              Your Google  account is connected
            </div>
          </div>
        </div>

        <button
          className="zoom-auth-logout"
          onClick={logout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
